import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DeletedPR extends CloudObject {

    /**
     * Creates an instance of DeletedPR.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(DeletedPR);
    }
    
    /**
     * @return {string}
     */
    getDeletedPrTag() {
        return this.get(DeletedPR.deletedPrTagProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeDeletedPrTag($) {
        return this.observe($, DeletedPR.deletedPrTagProp);
    }

    /**
     * @return {string}
     */
    getEprId() {
        return this.get(DeletedPR.eprIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeEprId($) {
        return this.observe($, DeletedPR.eprIdProp);
    }

    /**
     * @return {Date}
     */
    getDeletionDatetime() {
        return this.get(DeletedPR.deletionDatetimeProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeDeletionDatetime($) {
        return this.observe($, DeletedPR.deletionDatetimeProp);
    }

    /**
     * @return {string}
     */
    getUserId() {
        return this.get(DeletedPR.userIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeUserId($) {
        return this.observe($, DeletedPR.userIdProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setDeletedPrTag(transaction, instance, value) {
        transaction.update(instance, DeletedPR.deletedPrTagProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setEprId(transaction, instance, value) {
        transaction.update(instance, DeletedPR.eprIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setDeletionDatetime(transaction, instance, value) {
        transaction.update(instance, DeletedPR.deletionDatetimeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setUserId(transaction, instance, value) {
        transaction.update(instance, DeletedPR.userIdProp, value);
    }

}

// Hardcoded tags
register('018a654eda62ab42c6cf', DeletedPR);
DeletedPR.deletedPrTagProp = defineProperty('018a654f18c15410cecd');
DeletedPR.eprIdProp = defineProperty('018a654f548d2235c904');
DeletedPR.deletionDatetimeProp = defineProperty('018a654f9957f7d64423');
DeletedPR.userIdProp = defineProperty('018a654fda43fbedac2c');
